import { StatementReportItem } from "@merchant_api/models/statement-report-item";

export class StatementsState {
    loading = false;
    error = null;
    record: Array<StatementReportItem> = [];
}
